import type { RouteLocationRaw } from 'vue-router'
import { isNavigationFailure } from 'vue-router'
import { unref } from 'vue'
import type { RedirectRouter } from '../types'

export function replaceWithResolvedRoute (router: RedirectRouter, location: RouteLocationRaw): Promise<unknown> {
  return router.replace(location).then((failure: unknown) => {
    if (isNavigationFailure(failure)) {
      return Promise.reject(failure)
    }
    return unref(router.currentRoute)
  })
}
